import axios from 'axios';
import AppSettings from '../../../core/AppSettings';

// https://node-ui-chevrolet-live-accs-uat1.op-epg1.gm.com/wcs/resources/store/11201/yearmakemodel/vehicleCombinations/USA/2018/Chevrolet/Camaro
export const getVehicleCombinationsData = (year, make, model) => {
    const url = '/wcs/resources/store/' + AppSettings.storeId + '/yearmakemodel/vehicleCombinations/' + AppSettings.country + '/' + year + '/' + make + '/' + model
    // console.log('getVehicleCombinationsData url: ',url)
    return axios.get(url).then(response => response.data).catch(error => error);
};